// 3rd-party modules
import { useEffect, useState } from "react";

// project modules
import { apiCall } from "../../helpers/apiHelper";
import { convertToPersian } from "../../helpers/objectHelper";
import CustomChart from "../shared/chart/chart";
import Loader from "../shared/loader";
import useTranslation from "../../hooks/TranslationContext";

//apis
import * as SmsPanelApi from '../../apis/smsPanelApi';

//models
import { SmsPanelSentSmsStatisticModel } from "../../models/smsPanelSentSmsStatistic";

export default function SmsPanelSentSmsStatistics() {
  const { t } = useTranslation();

  const [datasource, setDatasource] = useState<SmsPanelSentSmsStatisticModel[]>([]);
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();

  const chartOptions = {
    chart: {
      type: 'line',
      toolbar: { show: false },
      zoom: {
        enabled: false,
        // type: 'x',
        // autoScaleYaxis: false,
        // allowMouseWheelZoom: true,
        // zoomedArea: {
        //   fill: {
        //     color: '#90CAF9',
        //     opacity: 0.4
        //   },
        //   stroke: {
        //     color: '#0D47A1',
        //     opacity: 0.4,
        //     width: 1
        //   }
        // }
      },
    },
    title: {
      text: t("sent-sms-statistics"),
      align: 'left'
    },
    xaxis: {
      categories: datasource.map(x => x.dateFa),
      title: { text: t("date") },
      labels: {
        rotate: -45, // Rotates labels counter-clockwise
        rotateAlways: true, // Ensures the rotation is always applied
        style: {
          fontSize: '12px',
          // fontWeight: 'bold',
        },
      },
    },
    yaxis: {
      title: { text: t("count") },
    },
    // stroke: { curve: 'smooth' },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd',
      },
    },
  };

  const chartSeries = [
    {
      name: t("count"),
      data: datasource.map(x => x.count),
    },
  ];

  useEffect(() => {
    getAccountSentSmsStatisticsAsync();
  }, []);

  const getAccountSentSmsStatistics = async (abortSignal?: AbortSignal) => {
    const response = await apiCall(SmsPanelApi.getAccountSentSmsStatistics(abortSignal));

    return response.success ? SmsPanelSentSmsStatisticModel.toArrayOfClass((response.data?.value || []).map((x: any) => { return {
      ...x,
      dateFa: convertToPersian(x.date)
    }})) : [];
  };

  const getAccountSentSmsStatisticsAsync = async () => {
    setLoading(true);
    setDatasource(await getAccountSentSmsStatistics(abortController.signal));
    setLoading(false);
  }

  return(
    <>
      {loading && <Loader/>}
      {!loading &&
      <CustomChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={250}
        width="100%"
      />}
    </>
  )
}
